<template>
    <div style="margin:0 -12px;">
        <HeaderMenu></HeaderMenu>
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <div style="padding:10px 0; overflow: hidden;" onclick="window.location.href = '/auth'">
                            <div class="item">
                                <svg style="height:36px;width:39px;fill:#5538EE;">
                                    <use xlink:href="/images/luna_logo.svg#luna_logo"></use>
                                </svg>
                            </div>
                            <div class="item">
                                <div class="logo" style="color: #5538EE;">Luna</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 text-center">
                        <a class="libere-header-menu" data-bs-toggle="offcanvas" href="#offcanvasRight"
                            aria-controls="offcanvasRight" style="outline: none">
                            <div class="" style="color:#5538EE;padding-top:7px;">
                                <svg style="height:25px;width:25px;fill:#5538EE;">
                                    <use xlink:href="/images/menu.svg#menu"></use>
                                </svg>
                                <div class="text-nowrap" style="font-size: 8px;">
                                    メニュー
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" style="padding-top:56px;">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div style="padding:0 17px;">
                            <br>
                            <div style="font-weight: 600;font-size: 20px;line-height: 30px;">
                                SMの話はしなかったのに…自然と惹かれ合い、パートナーへ。
                            </div>
                            <div style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:10px 0;">
                                2023年11月22日
                            </div>
                            <br>
                            <img src="/images/Group13345_2.png" class="img-fluid">
                            <div class="text-center"
                                style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:15px 0;">
                                ソウタさん・男性30代 関東<br />
                                りんさん・女性20代 関東
                            </div>
                            <br>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを始めたキッカケ</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span
                                    style="color:#6B4EFF">ソウタ</span>：Lunaのことは、かなり初期からTwitter(X)で見かけていました。マッチング系のサイトは作るのが大変なので、なかなか難しいだろうなと思っていたら、すごくバズっていて。<br />
                                当時はパートナーがいたので、登録することはないと考えていましたが…別れることになってしまいまして。<br />
                                SMバーに行った際に失恋を話題にして、その場のノリで始めたという感じでした。<br />
                                Lunaのプロフィールを登録していた際に、SとMのグラフ(※プロフィール内で設定できる「チャート」)で「あなたはこの辺」みたいな会話ですごく盛り上がりましたよ。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">りん</span>：私は、春頃にTwitter(X)でLunaの存在を知りました。<br />
                                面白そうだなと思って、「どんな人がいるんだろう？」という好奇心で始めてみて。<br />
                                最初は友達ができればいいなと思っていたんですけど。何度かLunaのアカウントを作り変えているうちに、「こういう風に書くと、こんな人が来る」という傾向が分かるようになっていきました。<br />
                                例えば、S寄りにプロフィールを書いた方が、丁寧な男性から連絡が来る気がします。<br />
                                最終的にプロフィールは、理想の主従について、「主と忍者(主人に仕える家臣)のような関係になりたい」というような表現になりました(笑)<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaは始めた頃どんな印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">ソウタ</span>：裏の人がすごく頑張って作っているなという印象がありました。<br />
                                初期のサービスに勢いが感じられたり、「今後、こうしていきたいんだろうな」という方向性が見えるのが面白かったです。<br />
                                あとは、「本当に好きな人が作っているんだろうな」と思いました。<br />
                                Twitter(X)で、「Lunaでは金銭のやり取りを禁止している」という話の補足に、「お貢ぎもダメですよ」と書いてあって、界隈への理解度を感じましたね。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">りん</span>：当時、大手のマッチングサイトではなかったので、大丈夫かなと思ったところはあるんですけど。<br />
                                身分証も、生年月日の確認が取れれば良かったですし、初期は男女ともに課金がなかったですし。<br />
                                サービスでこれをやってる人がいるってことは、ある意味、信頼が置けるのかなって。<br />
                                チャートの中で自分がどこに属するのか、求める条件とか、そういうのを絞って探せるのって面白いなと思いました。<br />
                                検索要素を色々変えて探してみたりもしました。<br />
                                アイコンも色々でしたし、プロフィールをすごく沢山書いている人から、本当に最低限だけという人もいて、面白かったです。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>お相手とやり取りをしていてお相手はどのような印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">ソウタ</span>：文章力が高いなと思いました。<br />
                                僕は小難しい話をするのが好きなんですけど、そういった話をすると、ついてくるどころかむしろこっちがついていかなきゃいけなくなるような会話をしてくることが多くて。<br />
                                すごく楽しかったです。<br />
                                会う前に、写真交換はしなかったんですけど。顔を見る前から、お互いに好感度は高かったです。通話もほぼしてなくて、やり取りはほとんどが文通って感じでした。<br />
                                しかも、ほぼSMの話はしてなかったですね。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">りん</span>：確かに、全然のSMの話はしてなくて。概念的な「どういうのが好きか」みたいな話をしていました。<br />
                                好きな漫画の話から、人生観の話まで、そういった話が多かった。どんなプレイがしたいとかは話していないと思います。<br />
                                <br />
                                <img src="/images/report7.png" class="img-fluid">
                                <br />
                                <br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>会ったときのお相手の印象</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span
                                    style="color:#6B4EFF">りん</span>：通話はタイミングが合わなかったのですが、「もう会っちゃおう」みたいな感じになって。（ソウタさんから、）Lunaでのやりとりで、「パートナーと別れたばかりなので、今は友達を探しています」というのが1通目に来ていたので。<br />
                                だからまぁ、「友達なのかな？」みたいに思っていたんですけど。<br />
                                <br />
                                <br />
                                <span style="color:#6B4EFF">ソウタ</span>：お互いに好感度は高かったのですが、「これは…どっちだ？」というのを探り合っていた感じでした。<br />
                                元々は「友達を探そう」くらいの話だったので、会う前は「ご飯おいしかったね！じゃあ、またそのうち遊ぼう。」で良いと思っていたのですが…。<br />
                                会ってみたら、なんだか気が合ってきて。<br />
                                初対面では、食事と散歩をして、２回目に会った時に付き合おうという話になりました。<br />
                                <br />
                                <br />
                                <span style="color:#6B4EFF">りん</span>：告白されて、SMバーに連れて行かれました(笑)<br />
                                初めて会った日にはもう、「この人友達って言ってたやん…」って思ってたんです。私は。<br />
                                <br />
                                <br />
                                <span style="color:#6B4EFF">ソウタ</span>：それは、隙を見せる君が悪い(笑)<br />
                                お互いに、分かってはいたなって感じでした。「あれ？これ好きだな」って。<br />
                                <br />
                                <img src="/images/report8.png" class="img-fluid">
                                <br />
                                <br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>現在はどのようなご関係なんですか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">ソウタ</span>：現在は、カップルです。SMパートナーというより、彼氏彼女という感じ。<br />
                                <br />
                                <br />
                                <span style="color:#6B4EFF">りん</span>：なので、最初にそういうことをした時には、「この人本当にSだったんだな」と思いました(笑)<br />
                                <br />
                                <img src="/images/report9.png" class="img-fluid">
                                <br />
                                <br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを使われる方へ一言</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">ソウタ</span>：数が大事というのは、あえて言いたいです。<br />
                                「（りんさんに対して、）この子だな」とはすごく思ったのですが、すぐに見つかった訳ではないです。気長に色んな人とメッセージのやり取りをしていたら、最終的には良い人が見つかりました。<br />
                                やっぱり、やり取りをしていても連絡が途絶えてしまう相手もいると思います。突然連絡が来なくなったら、「きっと良い人が見つかったんだな」と思うようにしていました。<br />
                                そのマインドはすごく大事だったと思います。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">りん</span>：個人的には、Twitter運用や、プロフィールを真面目に書くというのは大事だと思います。<br />
                                内容に「アカウント作りました」だけ書いて、Twitterが動いていなかったり、カードの登録もされていないと、その人がどういう人なのか分からない。<br />
                                自分のプロフィールをちゃんと書いて、相手のプロフィールもちゃんと読んで、それからちょっと喋ってみたら良いんじゃないかと思います。<br />
                                何を書けば良いか分からない場合は、人と喋っていくうちに分かってくることとかもあると思うので、分からないところに関しては「分かりません」と書いた方が、それはそれで素直で良いんじゃないかと思います。<br />
                                Lunaを通してお友達になったM女性とも交友関係が続いているのですが、出会い目的だけでなく、人間関係を広げて自分を理解するという意味でも、正直になることは大事だと思います。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">ソウタ</span>：あと、僕の場合はわざと、性的な話を自分からしないようにしていました。<br />
                                別にそれを話したい訳でもないし、その話から盛り上がるのって、やることがしたい人ですってことになってしまうので。<br />
                                女性側から、なんだかんだで興味があって聞いてくることが多いので、そこで話そうという風にしていました。<br />
                                でも、最後の最後まで全く聞かれなかったのは、彼女が初めてでした。<br />
                            </div>
                            <br>
                            <br>
                            <br>
                            <div style="border-radius: 6px;border: 1px solid #D9D9D9;padding:10px 0;"
                                onclick="window.location.href = '/report/page3'">
                                <div class="row d-flex align-items-center">
                                    <div class="col-2 px-0 text-center" style="">
                                        <svg style="height:14px;width:9px;fill:#E6E6E6;">
                                            <use xlink:href="/images/<.svg#page_left"></use>
                                        </svg>
                                    </div>
                                    <div class="col-2 px-0">
                                        <img src="/images/Group13342.png" class="img-fluid">
                                    </div>
                                    <div class="col">
                                        <div style="font-size:10px;color#999">前のレポート</div>
                                        <div style="font-size:12px;">Lunaに出会って人生が大きく変わりました！</div>
                                    </div>
                                    <div class="col-2 px-0">
                                    </div>
                                </div>
                            </div>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import HeaderMenu from '../HeaderMenu.vue'
import Footer from '../FooterLogin.vue'

export default {
    data() {
        return {
        };
    },
    components: {
        HeaderMenu: HeaderMenu,
        Footer: Footer,
    }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=MuseoModerno:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Alegreya+Sans+SC:wght@700&display=swap');

a {
    color: #6B4EFF;
    text-decoration:none;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}


.item {
    float: left;
}

.logo {
    font-size: 30px;
    line-height: 30px;
    padding-top: 5px;
    padding-left: 5px;
}

.login-box {
    width: 100%;
    border-radius: 20px;
    background-color: #fff;
    padding: 25px;
}

.item_box {
    padding: 30px 25px;
    background: #FFFFFF;
    border-radius: 10px;
}
</style>
